import { PostHogProvider } from '@posthog/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'core-js/actual/object/has-own';
import 'core-js/proposals/array-flat-map'; // added to tsconfig li.js';
import 'core-js/proposals/string-replace-all'; // added to tsconfig li.js';
import { ScreenSizeProvider } from 'page-context/column-layout/column-layout-context.js';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { store } from 'redux-state/configure-store.js';
import 'regenerator-runtime/runtime.js';
import 'styles/app.scss';
import { AdUtilsInit } from 'utilities/adUtils/adUtils.js';
import { ddConfigInit } from 'utilities/helpers/config.dataDog.js';
import { nielsenInit } from 'utilities/helpers/config.nielsen';
import { AppVersionProvider } from 'utilities/hooks/context-app-version.js';
import { router } from 'utilities/router/router-base';
import { getWindow, setWindow } from 'utilities/window.js';
import posthog from 'posthog-js';
import { initPostHog } from 'utilities/posthog-tracking';

// Initialize PostHog
initPostHog(
  import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN,
  import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  import.meta.env.MODE
);

const lclWindow = getWindow();

if (lclWindow) {
  lclWindow.MetService = lclWindow?.MetService || {};
  lclWindow.AdUtils = lclWindow.AdUtils || AdUtilsInit();
}

/** DataDog */
ddConfigInit();

/** Nielson */
setWindow('nielsenQueue', nielsenInit());

const queryClient = new QueryClient();

// from public/index.html

const el = lclWindow?.document?.getElementById?.('root');
if (el) {
  const root = createRoot(el);
  root.render(
    <AppVersionProvider>
      <PostHogProvider client={posthog}>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <ScreenSizeProvider>
              <RouterProvider router={router} />
            </ScreenSizeProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </Provider>
      </PostHogProvider>
    </AppVersionProvider>,
  );
}
